import "./SmokedMenu.module.css";
import TopNavigation from "@/reusable_sections/Header";
import CutsMenu from "./sections/CutsMenu";
import SidesAndSauces from "./sections/SidesAndSauces";
import HomeServingTips from "./sections/HomeServingTips";
import FooterSection from "@/reusable_sections/Footer";
export default function SmokedMenuPage() {
  return <div>
      <TopNavigation />
      <CutsMenu />
      <SidesAndSauces />
      <HomeServingTips />
      <FooterSection />
    </div>;
}